<template>
    <v-menu
        v-model ="show"
        :position-x ="68"
        :position-y="222"
        absolute
        offset-y
        nudge-top="-4"
        @input  = "onInput"
    >
        <div class="history-title primary white--text">
            {{ $t('unit.tzb.history') }}
        </div>
        <v-list>
            <v-list-item
                v-for  = "(item, index) in history"
                :key   = "index"
                @click = "onSelected(item)"
            >
                <div class="v-flex">
                    <div class="history-date">
                        {{ formatDate (item.date) }}
                    </div>
                    <div >
                        {{ item.technician }}
                    </div>
                </div>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>

import Core from "@/modules/core/service/Core";

export default {
    name: "PSiteTzbHistory",

    props: {
        value: {

        },

        unit: {

        },

        history: {

        },

        current: {

        }
    },

    data: () => ({
        show: false,
    }),

    mounted() {
        this.show = this.value;
    },

    watch: {
        value () {
            this.show = this.value;
        },
    },

    methods: {
        onInput () {
            if (!this.show) {
                this.$emit("input", false)
            }
        },

        onSelected (item) {
            this.$emit("selected", item);
        },

        formatDate (value) {
            return Core.format.date.display(value);
        }
    }
}
</script>

<style scoped>

.history-title {
    height: 32px;
    padding-left: 8px;
    padding-top: 4px;
    font-size: 16px;
}

.history-date {
    width: 120px;
}

:deep(.v-list-item) {
    min-height: 40px;
}

</style>